import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d5e2db4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "square-buttons" }
const _hoisted_2 = { class: "circular-border" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Compras Online", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Benefícios exlusivos nas melhores lojas.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("header", {
            style: _normalizeStyle({
          backgroundImage: `url(https://cdn.thelivery.com.br/img/assets/banners/stores.png)`,
        })
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_ion_button, {
                class: "button-header",
                fill: "clear",
                onClick: $options.goBack
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: $setup.arrowBack,
                    color: "light"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ], 4),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storesRef, (store) => {
                      return (_openBlock(), _createBlock(_component_ion_col, {
                        key: store.id,
                        size: "6",
                        "size-sm": "6",
                        "size-md": "4",
                        "size-lg": "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, {
                            onClick: ($event: any) => ($options.openModal(store))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_img, {
                                    src: store.logo
                                  }, null, 8, ["src"]),
                                  _createElementVNode("p", null, _toDisplayString(store.name), 1),
                                  _createElementVNode("span", null, _toDisplayString(store.description), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}